import { memo } from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

export interface DisableAutomationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DisableAutomationDialog = memo(
  ({ open, onClose, onConfirm }: DisableAutomationDialogProps) => {
    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
        <DialogTitle sx={{ pr: 6 }}>
          Desabilitar automação
          <IconButton
            aria-label="Fechar"
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8, color: "text.secondary" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Stack spacing={1}>
            <Typography variant="body2" color="text.secondary">
              Isso vai remover a configuração desta automação. Você poderá ativar novamente
              quando quiser.
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Quer desabilitar agora?
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="inherit" sx={{ textTransform: "none" }}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={onConfirm}
            sx={{ textTransform: "none" }}
          >
            Desabilitar
          </Button>
        </DialogActions>
      </Dialog>
    );
  },
);

DisableAutomationDialog.displayName = "DisableAutomationDialog";

export default DisableAutomationDialog;
